import styled from 'styled-components';

const CardTitle = styled.h3`
  margin-bottom: 4px;
  font-size: 20px;
`;

export default CardTitle;
